import { Directive, ElementRef, Optional } from '@angular/core';
import {
  MatDialogClose,
  MatDialog,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { Dialog, DialogRef } from '@angular/cdk/dialog';

@Directive({
  selector: 'button[pt-dialog-close], button[ptDialogClose]',
  exportAs: 'prConnectedDialogClose',
  host: {
    '(click)': 'dialogRef.close(dialogResult)',
    '[attr.aria-label]': 'ariaLabel || null',
    type: 'button', // Prevents accidental form submits.
  },
  standalone: false,
})
export class ConnectedDialogCloseDirective extends MatDialogClose {
  constructor(
    @Optional() dialogRef: DialogRef<unknown>,
    elementRef: ElementRef<HTMLElement>,
    dialog: Dialog
  ) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    super(dialogRef, elementRef, dialog as unknown as MatDialog);
  }
}

@Directive({
  selector: '[pt-dialog-title], [ptDialogTitle]',
  exportAs: 'ptDialogTitle',
  host: {
    class: 'pt-dialog-title',
    '[id]': 'id',
  },
  standalone: false,
})
export class ConnectedDialogTitleDirective extends MatDialogTitle {
  constructor(
    @Optional() dialogRef: DialogRef<unknown>,
    elementRef: ElementRef<HTMLElement>,
    dialog: Dialog
  ) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    super(dialogRef, elementRef, dialog as unknown as MatDialog);
  }
}

@Directive({
  selector: `[pt-dialog-content], pt-dialog-content, [ptDialogContent]`,
  host: { class: 'pt-dialog-content' },
  standalone: false,
})
export class ConnectedDialogContentDirective extends MatDialogContent {}

@Directive({
  selector: `[pt-dialog-actions], pt-dialog-actions, [ptDialogActions]`,
  host: { class: 'pt-dialog-actions' },
  standalone: false,
})
export class ConnectedDialogActionsDirective extends MatDialogActions {}
